/**
 * Triggers the download of a CSV file on the client's browser
 * This snippet was taken and adapted from `js-file-download`
 * https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
 * @param {String} data - stringified CSV data
 * @param {String} filename - including extension
 * @param {*} linkElementRef - React ref to download link element
 */
const download = (data, filename, linkElementRef) => {
    const blob = new Blob(['\uFEFF', data], {
        type: 'text/csv;charset=utf-8;',
    });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    } else {
        const blobURL =
            window.URL && window.URL.createObjectURL
                ? window.URL.createObjectURL(blob)
                : window.webkitURL.createObjectURL(blob);
        linkElementRef.setAttribute('href', blobURL);
        linkElementRef.setAttribute('download', filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof linkElementRef.download === 'undefined') {
            linkElementRef.setAttribute('target', '_blank');
        }

        linkElementRef.click();

        // Fixes "webkit blob resource error 1"
        setTimeout(() => {
            window.URL.revokeObjectURL(blobURL);
        }, 200);
    }
};

/**
 * Triggers the download of an excel file on the client's browser
 * @param {Object[]} data - excel data as buffer array
 * @param {String} filename - the filename that will be used by the downloaded file
 */
export const downloadExcel = (data, filename) => {
    const blob = new Blob([data], {
        type: 'application/octet-stream',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.download = filename;
    a.href = url;
    document.body.appendChild(a);
    a.click();
};

export default download;
